import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'

const configOptions = {
  apiKey: "AIzaSyCtMCBWDuk6zpFfnUUNdGaaysU5dZoDVJE",
  authDomain: "codeway-shared.firebaseapp.com",
  databaseURL: "https://codeway-shared.firebaseio.com",
  projectId: "codeway-shared",
  storageBucket: "codeway-shared.appspot.com",
  messagingSenderId: "821633703997",
  appId: "1:821633703997:web:4645f51ab4c9114a564a54"
};

firebase.initializeApp(configOptions);

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("setUser", user);
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
